import React from "react";
import InputMask from "react-input-mask";

const PhoneInput = props => <InputMask {...props} mask="(99) 99999-9999" maskChar="" />;

export default PhoneInput;
